<template>
  <div>
    {{ text }}
    <v-menu bottom offset-y max-width="340" max-height="340">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon small :color="getColor(color)" dark>
            {{ icon ? icon : "mdi-map-marker-radius-outline" }}
          </v-icon>
        </v-btn>
      </template>
      <v-list class="py-4" width="300px" max-height="300px">
        <v-list-item>
          <MapsVT
            width="250px"
            height="250px"
            :options="map_config"
            :items="item"
          ></MapsVT> </v-list-item
      ></v-list>
    </v-menu>
  </div>
</template>

<script>
import MapsVT from "../components/MapsVT";

export default {
  name: "MapTooltipVT",
  components: { MapsVT },
  props: {
    text: String,
    item: Array,
    color: String,
    icon: String,
    map_config: Object,
  },
  watch: {},
  data: function () {
    return {
      on_click: true,
      dialog: false,
    };
  },
  methods: {
    getColor(color) {
      return color ? color : "primary";
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
